import { Link } from "react-router-dom";
import { Instagram, Twitter } from "lucide-react";

const CATEGORIES = [
  "nature", "architecture", "people", "abstract",
  "travel", "food", "business", "animals",
];

export default function Footer() {
  return (
    <footer className="bg-ink text-ivory mt-24" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <Link to="/dashboard" className="font-serif text-2xl tracking-tight">
            Elite<span className="text-gold">Stock</span>
          </Link>
          <p className="mt-4 text-sm text-ivory/70 leading-relaxed max-w-xs">
            A hand-curated library of gallery-grade photography for editors,
            designers and brands. Refreshed daily.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a href="#" aria-label="Instagram" className="h-9 w-9 inline-flex items-center justify-center border border-ivory/25 hover:border-gold hover:text-gold transition-colors">
              <Instagram className="h-4 w-4" />
            </a>
            <a href="#" aria-label="Twitter" className="h-9 w-9 inline-flex items-center justify-center border border-ivory/25 hover:border-gold hover:text-gold transition-colors">
              <Twitter className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-ivory/60 mb-4">Explore</div>
          <ul className="space-y-2 text-sm">
            {CATEGORIES.slice(0, 4).map((c) => (
              <li key={c}>
                <Link
                  to={`/dashboard/search?q=${c}`}
                  className="text-ivory/85 hover:text-gold transition-colors capitalize"
                >
                  {c}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-ivory/60 mb-4">Discover</div>
          <ul className="space-y-2 text-sm">
            {CATEGORIES.slice(4).map((c) => (
              <li key={c}>
                <Link
                  to={`/dashboard/search?q=${c}`}
                  className="text-ivory/85 hover:text-gold transition-colors capitalize"
                >
                  {c}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-ivory/60 mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#about" className="text-ivory/85 hover:text-gold transition-colors">About</a></li>
            <li><a href="#license" className="text-ivory/85 hover:text-gold transition-colors">Licensing</a></li>
            <li><a href="#contact" className="text-ivory/85 hover:text-gold transition-colors">Contact</a></li>
            <li><a href="https://depositphotos.com" target="_blank" rel="noreferrer" className="text-ivory/85 hover:text-gold transition-colors">Photo credits</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-ivory/12">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-5 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-ivory/60">
          <div>© {new Date().getFullYear()} EliteStock. Photos courtesy of Depositphotos.</div>
          <div className="flex items-center gap-5">
            <a href="#privacy" className="hover:text-gold">Privacy</a>
            <a href="#terms" className="hover:text-gold">Terms</a>
            <a href="#license" className="hover:text-gold">License</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
